import { toTitleCase } from "../../../Utils/stringUtls";
import {
  credit_dataMigAttr,
  credit_programType,
  dataMigerationTypewithValue
} from "../../CreditForm/ProgramInformation/FieldsListingLabels";
import {
  commercialPrepaid,
  consumerPrepaid,
  dataMigAttr,
  dataMigInfo,
  generalEntityType,
  programTypeDebit,
  programTypePrepaid,
} from "../ProgramInformation/FieldsListingLabels";
import { timeZones } from "../ProgramInformation/ProgramInformation";

const ProgramInformationOverview = ({ data, type = "debit" }) => {

  const programTypeDebitLabels = programTypeDebit.map((el) => el.label);
  if (!data) return null;
  const data1 = data["0_0"];
  const {
    pi_program_name,
    pi_standard_time,
    pi_program_debit_or_credit,
    pi_card_program,
    pi_program_type_prepaid,
    //only credit field
    pi_program_type,
    pi_type_of_migration,
    pi_type_of_processor_name,

    pi_system_records_debit,
    pi_system_records_debit_other,
    pi_auth_transac_debit,
    pi_auth_transac_debit_other,
    pi_program_type_debit,
    pi_program_type_debit_other,
    pi_selected_commercial_types,
    pi_selected_consumer_types,
    pi_commercial_type_other,
    pi_consumer_type_other,
    pi_proposition_value,
    pi_segment_value,
    pi_card_program_currency,
    pi_setup_type,
    pi_ecount_1,
    pi_ecount_2,
    pi_ecount_3,
    pi_ecount_4,
    pi_evalue_1,
    pi_evalue_2,
    pi_evalue_3,
    pi_evalue_4,
    pi_evolume_1,
    pi_evolume_2,
    pi_evolume_3,
    pi_evolume_4,
    pi_current_processor_name,
    pi_key_component_custodians,
    pi_key_component_custodians_other,
    pi_data_migration_attributes,
    pi_data_migration_attributes_other,
    pi_cpm_compliant,
    pi_migration_type,
    pi_mig_np_ecount_1,
    pi_mig_np_ecount_2,
    pi_mig_np_ecount_3,
    pi_mig_np_ecount_4,
    pi_mig_np_evalue_1,
    pi_mig_np_evalue_2,
    pi_mig_np_evalue_3,
    pi_mig_np_evalue_4,
    pi_mig_np_evolume_1,
    pi_mig_np_evolume_2,
    pi_mig_np_evolume_3,
    pi_mig_np_evolume_4,
    pi_mig_mp_ecount_1,
    pi_mig_mp_ecount_2,
    pi_mig_mp_ecount_3,
    pi_mig_mp_ecount_4,
    pi_mig_mp_evalue_1,
    pi_mig_mp_evalue_2,
    pi_mig_mp_evalue_3,
    pi_mig_mp_evalue_4,
    pi_mig_mp_evolume_1,
    pi_mig_mp_evolume_2,
    pi_mig_mp_evolume_3,
    pi_mig_mp_evolume_4,
  } = data1;
  const migrationTypeObj = dataMigerationTypewithValue.find(item => item.value === pi_migration_type);

  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid gap-sm" className="">
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Program Name</div>
          <div className="overview-val-text">
            {pi_program_name?.length ? pi_program_name : "-"}
          </div>
        </div>
        {type === "debit" && (
          <div i2c-grid="6@md">
            <div className="overview-help-text font-bold">
              Instance Time Zone for Reporting
            </div>
            <div className="overview-val-text">
              {pi_standard_time?.length
                ? timeZones.find((zon) => zon.value === pi_standard_time)?.label
                : "-"}
            </div>
          </div>
        )}
        {type === "debit" ? (
          <div i2c-grid="12@md">
            <div className="overview-help-text font-bold">
              Will the program be Debit or Prepaid
            </div>
            <div className="overview-val-text">
              {pi_program_debit_or_credit?.length
                ? toTitleCase(pi_program_debit_or_credit)
                : "-"}
            </div>
          </div>
        ) : null}
        {pi_program_debit_or_credit === "debit" && (
          <>
            <div i2c-grid="12@md">
              <div className="overview-help-text font-bold">
                Who would be the system of records?
              </div>
              <div className="overview-val-text">
                {pi_system_records_debit.map((entity, index) => {
                  return (
                    <span key={index}>
                      {generalEntityType[entity].label === "Other"
                        ? pi_system_records_debit_other + ", "
                        : generalEntityType[entity].label + ", "}
                    </span>
                  );
                })}
              </div>
            </div>

            <div i2c-grid="12@md">
              <div className="overview-help-text font-bold">
                Who would be authorizing the transactions?
              </div>
              <div className="overview-val-text">
                {pi_auth_transac_debit.map((entity, index) => {
                  return (
                    <span key={index}>
                      {generalEntityType[entity].label === "Other"
                        ? pi_auth_transac_debit_other + ", "
                        : generalEntityType[entity].label + ", "}
                    </span>
                  );
                })}
              </div>
            </div>
          </>
        )}
        {pi_program_debit_or_credit === "prepaid" && (
          <div i2c-grid="12@md">
            <div className="overview-help-text font-bold">
              Reloadable or Non-Reloadable Card Program
            </div>
            <div className="overview-val-text">
              {pi_card_program?.length ? toTitleCase(pi_card_program) : "-"}
            </div>
          </div>
        )}
        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold">Program Type</div>
          {
            type === "debit" ? (
              <div className="overview-val-text">
                {pi_program_debit_or_credit === "prepaid"
                  ? programTypePrepaid[pi_program_type_prepaid]?.label
                  : pi_program_type_debit
                    ?.map((a) =>
                      programTypeDebitLabels[a] === "Other"
                        ? pi_program_type_debit_other
                        : programTypeDebitLabels[a],
                    )
                    ?.map((val, index) => (
                      <span key={index}>{val + ", "}</span>
                    ))}
              </div>
            ) : (
              <div className="overview-val-text">
                {credit_programType.find(
                  (type) => type.value === pi_program_type,
                )?.label ?? ""}
              </div>
            )
            // credit_programType
          }
        </div>

        {type === "debit" &&
          pi_program_type_prepaid === 0 &&
          pi_program_debit_or_credit !== "debit" ? (
          <div i2c-grid="12@md">
            <div className="overview-help-text font-bold">
              Consumer Type Channels
            </div>
            <div className="overview-val-text">
              {pi_selected_consumer_types
                ?.map((a) =>
                  a === 7 ? pi_consumer_type_other : consumerPrepaid[a].label,
                )
                ?.map((val, index) => (
                  <li key={index}>{val + ", "}</li>
                ))}
            </div>
          </div>
        ) : (
          type === "debit" &&
          pi_program_debit_or_credit !== "debit" &&
          pi_program_type_prepaid === 1 && (
            <div i2c-grid="12@md">
              <div className="overview-help-text font-bold">
                Commercial Type Channels
              </div>
              <div className="overview-val-text">
                {pi_selected_commercial_types
                  ?.map((a) =>
                    a === 4
                      ? pi_commercial_type_other
                      : commercialPrepaid[a].label,
                  )
                  ?.map((val, index) => (
                    <li key={index}>{val + ", "}</li>
                  ))}
              </div>
            </div>
          )
        )}

        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold">
            Program Description
          </div>
          <div className="overview-val-text" i2c-grid="grid 6@md">
            <div>
              <div className="overview-help-text">
                What is the value proposition, how is the program different form
                other options in the market?
              </div>
              <div className="overview-val-text">
                {pi_proposition_value?.length ? pi_proposition_value : "-"}
              </div>
            </div>
            <div>
              <div className="overview-help-text">
                Which segment of the market is this program going to be targeted
                towards?
              </div>
              <div className="overview-val-text">
                {pi_segment_value?.length ? pi_segment_value : "-"}
              </div>
            </div>
          </div>
        </div>

        {type === "debit" ? (
          <div i2c-grid="12@md">
            <div className="overview-help-text font-bold">
              Card Program Currency
            </div>
            <div className="overview-help-text">
              Please confirm the currencies in which the cardholder balances
              will be maintained
            </div>
            <div className="overview-val-text">
              {pi_card_program_currency?.length
                ? pi_card_program_currency
                : "-"}
            </div>
          </div>
        ) : null}

        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold">Setup Type</div>
          <div className="overview-val-text">
            {pi_setup_type?.length ? toTitleCase(pi_setup_type) : "-"}
          </div>
        </div>





        {pi_setup_type !== "migration" && type !== "credit" && (
          <div i2c-grid="12@md">
            <div className="overview-help-text font-bold">
               Projection at Launch
            </div>
            <div className="overview-val-text" i2c-grid="grid 6@md">
              <div>
                <div className="overview-help-text font-bold">
                  Estimated Count (Number of cards to be migrated)
                </div>
                <div className="overview-val-text">
                  {pi_ecount_1 +
                    "," +
                    pi_ecount_2 +
                    "," +
                    pi_ecount_3 +
                    "," +
                    pi_ecount_4}
                </div>
              </div>
              <div>
                <div className="overview-help-text font-bold">
                  Estimated Value (Estimated transaction value)
                </div>
                <div className="overview-val-text">
                  {pi_evalue_1 +
                    "," +
                    pi_evalue_2 +
                    "," +
                    pi_evalue_3 +
                    "," +
                    pi_evalue_4}
                </div>
              </div>

              <div>
                <div className="overview-help-text font-bold">
                  Estimated Volume (Estimated transaction volume)
                </div>
                <div className="overview-val-text">
                  {pi_evolume_1 +
                    "," +
                    pi_evolume_2 +
                    "," +
                    pi_evolume_3 +
                    "," +
                    pi_evolume_4}
                </div>
              </div>
            </div>
          </div>
        )}

        {((pi_setup_type === "migration" && type !== "credit") || type === "credit") && (
          <div i2c-grid="12@md">
            {
              pi_setup_type === "migration" && (

                <>
                  <div className="overview-val-text" i2c-grid="grid 6@md">
                    <div>
                      <div className="overview-help-text font-bold">
                        Type of Migration
                      </div>
                      <div className="overview-val-text">
                        {pi_type_of_migration?.length
                          ? toTitleCase(pi_type_of_migration.replace("-", " "))
                          : "-"}
                      </div>
                    </div>
                  </div>
                  {type === "debit" ? (
                    <div className="overview-val-text mt-16">
                      <div className="overview-help-text font-bold">
                         Please specify the bank or processor name
                      </div>
                      <div className="overview-val-text">
                        {pi_type_of_processor_name?.length
                          ? pi_type_of_processor_name
                          : "-"}
                      </div>
                    </div>
                  ) : (
                    <div className="overview-val-text mt-16" i2c-grid="">
                      <div>
                        <div className="overview-help-text font-bold">
                          Bank or Current Processor Name
                        </div>
                        <div className="overview-val-text">
                          {pi_type_of_processor_name?.length
                            ? pi_type_of_processor_name
                            : "-"}
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )
            }




            {type === "credit" ? (
              <>
                <div className="mt-16 overview-help-text font-bold">
                  Data Migration Information
                </div>
                <div className="overview-val-text mt-4" i2c-grid="">
                  <div>
                    <div className="overview-help-text font-bold">
                      Current Processor Name
                    </div>
                    <div className="overview-val-text">
                      {pi_current_processor_name?.length
                        ? pi_current_processor_name
                        : "-"}
                    </div>
                  </div>
                </div>
              </>
            ) :  <>
            <div className="mt-16 overview-help-text font-bold">
              Data Migration Information
            </div>
            <div className="overview-val-text mt-4" i2c-grid="">
              <div>
                <div className="overview-help-text font-bold">
                  Current Processor Name
                </div>
                <div className="overview-val-text">
                  {pi_current_processor_name?.length
                    ? pi_current_processor_name
                    : "-"}
                </div>
              </div>
            </div>
          </>}

            <div className="mt-16">
              <div className="overview-help-text font-bold">
                Existing Clear Key Components Custodian
              </div>
              {pi_key_component_custodians.map((custodian, index) => {
                return (
                  <span key={index}>
                    {dataMigInfo[custodian].label === "Other"
                      ? pi_key_component_custodians_other + ", "
                      : dataMigInfo[custodian].label + ", "}
                  </span>
                );
              })}
            </div>
          </div>
        )}
        {type == "credit" && (
          <div i2c-grid="12@md">
            <div className="overview-help-text font-bold">
              Migration Attributes
            </div>
            <div className="overview-val-text">
              <ul
                className="mt-0 mb-0 "
                style={{ paddingLeft: "var(--i2c-spacing-5)" }}
              >
                {credit_dataMigAttr.map((attr, index) => {
                  if (pi_data_migration_attributes.includes(attr.value)) {
                    if (attr.value === 16)
                      return (
                        <li key={index}>
                          {pi_data_migration_attributes_other?.length
                            ? pi_data_migration_attributes_other
                            : "-"}
                        </li>
                      );
                    return <li key={index}>{attr.label}</li>;
                  }
                })}
              </ul>
            </div>
          </div>
        )}
        {type == "debit" && pi_setup_type === "migration" ? (
          <div i2c-grid="12@md">
            <div className="overview-help-text font-bold">
              Migration Attributes
            </div>
            <div className="overview-val-text">
              <ul
                className="mt-0 mb-0 "
                style={{ paddingLeft: "var(--i2c-spacing-5)" }}
              >
                {dataMigAttr.map((attr, index) => {
                  if (pi_data_migration_attributes.includes(attr.value)) {
                    if (attr.value === 4)
                      return (
                        <li key={index}>
                          {pi_data_migration_attributes_other?.length
                            ? pi_data_migration_attributes_other
                            : "-"}
                        </li>
                      );
                    return <li key={index}>{attr.label}</li>;
                  }
                })}
              </ul>
            </div>
          </div>
        ) : (
          ""
        )}


        {
          ((type === "debit" && pi_setup_type === "migration") || type == "credit") && (
            <div i2c-grid="12@md">
              <div className="overview-help-text font-bold">
                Data Migration
              </div>
              <div className="overview-val-text">

                {migrationTypeObj ? (
                  migrationTypeObj.label
                ) : (
                  "Unknown Migration Type"
                )}


              </div>
            </div>
          )
        }
        {pi_setup_type !== "migration" &&
          (pi_migration_type === "new-program" ||
            pi_migration_type === "both") &&
          type === "credit" && (
            <div i2c-grid="12@md">
              <div className="overview-help-text font-bold">
                New Program Projections
              </div>
              <div className="overview-val-text" i2c-grid="grid 6@md">
                <div>
                  <div className="overview-help-text font-bold">
                    Estimated Count (Number of cards to be migrated)
                  </div>
                  <div className="overview-val-text">
                    {pi_mig_np_ecount_1 +
                      "," +
                      pi_mig_np_ecount_2 +
                      "," +
                      pi_mig_np_ecount_3 +
                      "," +
                      pi_mig_np_ecount_4}
                  </div>
                </div>
                <div>
                  <div className="overview-help-text font-bold ">
                    Estimated Value (Estimated transaction value)
                  </div>
                  <div className="overview-val-text">
                    {pi_mig_np_evalue_1 +
                      "," +
                      pi_mig_np_evalue_2 +
                      "," +
                      pi_mig_np_evalue_3 +
                      "," +
                      pi_mig_np_evalue_4}
                  </div>
                </div>

                <div>
                  <div className="overview-help-text font-bold">
                    Estimated Volume (Estimated transaction volume)
                  </div>
                  <div className="overview-val-text">
                    {pi_mig_np_evolume_1 +
                      "," +
                      pi_mig_np_evolume_2 +
                      "," +
                      pi_mig_np_evolume_3 +
                      "," +
                      pi_mig_np_evolume_4}
                  </div>
                </div>
              </div>
            </div>
          )}

        {pi_setup_type === "new-program" &&
          pi_migration_type !== "new-program" &&
          type === "credit" && (
            <div i2c-grid="12@md">
              <div className="overview-help-text font-bold">
                Migration Program Projections
              </div>
              <div className="overview-val-text" i2c-grid="grid 6@md">
                <div>
                  <div className="overview-help-text font-bold">
                    Estimated Count (Number of cards to be migrated)*
                  </div>
                  <div className="overview-val-text">
                    {pi_mig_mp_ecount_1 +
                      "," +
                      pi_mig_mp_ecount_2 +
                      "," +
                      pi_mig_mp_ecount_3 +
                      "," +
                      pi_mig_mp_ecount_4}
                  </div>
                </div>
                <div>
                  <div className="overview-help-text font-bold">
                    Estimated Value (Transaction value of the migrated cards)*
                  </div>
                  <div className="overview-val-text">
                    {pi_mig_mp_evalue_1 +
                      "," +
                      pi_mig_mp_evalue_2 +
                      "," +
                      pi_mig_mp_evalue_3 +
                      "," +
                      pi_mig_mp_evalue_4}
                  </div>
                </div>

                <div>
                  <div className="overview-help-text font-bold">
                    Estimated Volume (Transaction volume of the migrated cards)*
                  </div>
                  <div className="overview-val-text">
                    {pi_mig_mp_evolume_1 +
                      "," +
                      pi_mig_mp_evolume_2 +
                      "," +
                      pi_mig_mp_evolume_3 +
                      "," +
                      pi_mig_mp_evolume_4}
                  </div>
                </div>
              </div>
            </div>
          )}

        {
          pi_setup_type === "migration" &&
          (pi_migration_type === "new-program" ||
            pi_migration_type === "both") && (
            <div i2c-grid="12@md">
              <div className="overview-help-text font-bold">
                New Program Projections
              </div>
              <div className="overview-val-text" i2c-grid="grid 6@md">
                <div>
                  <div className="overview-help-text font-bold">
                    Estimated Count (Number of cards in sevice)
                  </div>
                  <div className="overview-val-text">
                    {pi_mig_np_ecount_1?.length ? pi_mig_np_ecount_1 : "-"},
                    {pi_mig_np_ecount_2?.length ? pi_mig_np_ecount_2 : "-"},
                    {pi_mig_np_ecount_3?.length ? pi_mig_np_ecount_3 : "-"},
                    {pi_mig_np_ecount_4?.length ? pi_mig_np_ecount_4 : "-"}
                  </div>
                </div>
                <div>
                  <div className="overview-help-text font-bold">
                    Estimated Value (Transaction value)
                  </div>
                  <div className="overview-val-text">
                    {pi_mig_np_evalue_1?.length ? pi_mig_np_evalue_1 : "-"},
                    {pi_mig_np_evalue_2?.length ? pi_mig_np_evalue_2 : "-"},
                    {pi_mig_np_evalue_3?.length ? pi_mig_np_evalue_3 : "-"},
                    {pi_mig_np_evalue_4?.length ? pi_mig_np_evalue_4 : "-"}
                  </div>
                </div>

                <div>
                  <div className="overview-help-text font-bold">
                    Estimated Volume (Transaction volume)
                  </div>
                  <div className="overview-val-text">
                    {pi_mig_np_evolume_1?.length ? pi_mig_np_evolume_1 : "-"},
                    {pi_mig_np_evolume_2?.length ? pi_mig_np_evolume_2 : "-"},
                    {pi_mig_np_evolume_3?.length ? pi_mig_np_evolume_3 : "-"},
                    {pi_mig_np_evolume_4?.length ? pi_mig_np_evolume_4 : "-"}
                  </div>
                </div>
              </div>
            </div>
          )
          // ) : (
          //   <div i2c-grid="12@md">
          //     <div className="overview-help-text font-bold">
          //       Migration Program Projections
          //     </div>
          //     <div className="overview-val-text" i2c-grid="grid 6@md">
          //       <div>
          //         <div className="overview-help-text font-bold">
          //           Estimated Count (Number of cards to be migrated)
          //         </div>
          //         <div className="overview-val-text">
          //           {pi_ecount_1?.length ? pi_ecount_1 : "-"},
          //           {pi_ecount_2?.length ? pi_ecount_2 : "-"},
          //           {pi_ecount_3?.length ? pi_ecount_3 : "-"},
          //           {pi_ecount_4?.length ? pi_ecount_4 : "-"}
          //         </div>
          //       </div>
          //       <div>
          //         <div className="overview-help-text font-bold">
          //           Estimated Value (Transaction value of the migrated cards)
          //         </div>
          //         <div className="overview-val-text">
          //           {pi_evalue_1?.length ? pi_evalue_1 : "-"},
          //           {pi_evalue_2?.length ? pi_evalue_2 : "-"},
          //           {pi_evalue_3?.length ? pi_evalue_3 : "-"},
          //           {pi_evalue_4?.length ? pi_evalue_4 : "-"}
          //         </div>
          //       </div>

          //       <div>
          //         <div className="overview-help-text font-bold">
          //           Estimated Value (Transaction volume of the migrated cards)
          //         </div>
          //         <div className="overview-val-text">
          //           {pi_evolume_1?.length ? pi_evolume_1 : "-"},
          //           {pi_evolume_2?.length ? pi_evolume_2 : "-"},
          //           {pi_evolume_3?.length ? pi_evolume_3 : "-"},
          //           {pi_evolume_4?.length ? pi_evolume_4 : "-"}
          //         </div>
          //       </div>
          //     </div>
          //   </div>
          // ))
        }
        {pi_setup_type === "migration" &&
          (pi_migration_type === "migration-program" ||
            pi_migration_type === "both") &&
          (type === "credit" ? (
            <div i2c-grid="12@md">
              <div className="overview-help-text font-bold">
                Migration Program Projections{" "}
              </div>
              <div className="overview-val-text" i2c-grid="grid 6@md">
                <div>
                  <div className="overview-help-text font-bold">
                    Count (Number of cards to be migrated)
                  </div>
                  <div className="overview-val-text">
                    {pi_mig_mp_ecount_1?.length ? pi_mig_mp_ecount_1 : "-"},
                    {pi_mig_mp_ecount_2?.length ? pi_mig_mp_ecount_2 : "-"},
                    {pi_mig_mp_ecount_3?.length ? pi_mig_mp_ecount_3 : "-"},
                    {pi_mig_mp_ecount_4?.length ? pi_mig_mp_ecount_4 : "-"}
                  </div>
                </div>
                <div>
                  <div className="overview-help-text font-bold">
                    Value (Estimated transaction value)
                  </div>
                  <div className="overview-val-text">
                    {pi_mig_mp_evalue_1?.length ? pi_mig_mp_evalue_1 : "-"},
                    {pi_mig_mp_evalue_2?.length ? pi_mig_mp_evalue_2 : "-"},
                    {pi_mig_mp_evalue_3?.length ? pi_mig_mp_evalue_3 : "-"},
                    {pi_mig_mp_evalue_4?.length ? pi_mig_mp_evalue_4 : "-"}
                  </div>
                </div>

                <div>
                  <div className="overview-help-text font-bold">
                    Volume (Estimated transaction volume)
                  </div>
                  <div className="overview-val-text">
                    {pi_mig_mp_evolume_1?.length ? pi_mig_mp_evolume_1 : "-"},
                    {pi_mig_mp_evolume_2?.length ? pi_mig_mp_evolume_2 : "-"},
                    {pi_mig_mp_evolume_3?.length ? pi_mig_mp_evolume_3 : "-"},
                    {pi_mig_mp_evolume_4?.length ? pi_mig_mp_evolume_4 : "-"}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div i2c-grid="12@md">
              <div className="overview-help-text font-bold">
                Migration Program Projections{" "}
              </div>
              <div className="overview-val-text" i2c-grid="grid 6@md">
                <div>
                  <div className="overview-help-text font-bold">
                    Count (Number of cards to be migrated)
                  </div>
                  <div className="overview-val-text">
                    {pi_ecount_1?.length ? pi_ecount_1 : "-"},
                    {pi_ecount_2?.length ? pi_ecount_2 : "-"},
                    {pi_ecount_3?.length ? pi_ecount_3 : "-"},
                    {pi_ecount_4?.length ? pi_ecount_4 : "-"}
                  </div>
                </div>
                <div>
                  <div className="overview-help-text font-bold">
                    Value (Estimated transaction value)
                  </div>
                  <div className="overview-val-text">
                    {pi_evalue_1?.length ? pi_evalue_1 : "-"},
                    {pi_evalue_2?.length ? pi_evalue_2 : "-"},
                    {pi_evalue_3?.length ? pi_evalue_3 : "-"},
                    {pi_evalue_4?.length ? pi_evalue_4 : "-"}
                  </div>
                </div>

                <div>
                  <div className="overview-help-text font-bold">
                    Volume (Estimated transaction volume)
                  </div>
                  <div className="overview-val-text">
                    {pi_evolume_1?.length ? pi_evolume_1 : "-"},
                    {pi_evolume_2?.length ? pi_evolume_2 : "-"},
                    {pi_evolume_3?.length ? pi_evolume_3 : "-"},
                    {pi_evolume_4?.length ? pi_evolume_4 : "-"}
                  </div>
                </div>
              </div>
            </div>
          ))}
        {type === "debit" && (
          <div i2c-grid="12@md">
            <div className="overview-help-text font-bold">
              Card Program Manager - PCI Compliant
            </div>
            <div className="overview-val-text">
              {pi_cpm_compliant?.length ? pi_cpm_compliant : "-"}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default ProgramInformationOverview;
